import PropTypes from 'prop-types';
import React from 'react';
import { withLocalize } from 'react-localize-redux';
import Icon, { IconSizes, IconVariants } from '../../components/foundations/Icon';
import Tooltip from '../../components/molecules/Tooltip';
import { SECTION_ACCESS_TYPES } from '../../utils/consts';
import { translationPrefix as translationRootPrefix, CUSTOM_ACCESS_TYPE } from '../utils';

const translationPrefix = `${translationRootPrefix}.MANAGE_PERMISSIONS_PAGE`;

const ICON_NAMES_BY_ACCESS_TYPE = {
    [SECTION_ACCESS_TYPES.VIEW]: 'eye',
    [SECTION_ACCESS_TYPES.EDIT]: 'check',
    [CUSTOM_ACCESS_TYPE]: 'adjustments-horizontal',
};

export const ICON_VARIANTS_BY_ACCESS_TYPE = {
    [SECTION_ACCESS_TYPES.VIEW]: IconVariants.ACTIVE,
    [SECTION_ACCESS_TYPES.EDIT]: IconVariants.SUCCESS,
    [CUSTOM_ACCESS_TYPE]: IconVariants.WARNING,
};

const AccessTypeIcon = ({ accessType, size = IconSizes.SMALL, wrapperClass = '' }) => (
    <Tooltip
        titleTranslationKey={`${translationPrefix}.SECTION_ACCESS_TYPES.${accessType}`}
        wrapperClass={wrapperClass}
    >
        <Icon
            name={ICON_NAMES_BY_ACCESS_TYPE[accessType]}
            size={size}
            variant={ICON_VARIANTS_BY_ACCESS_TYPE[accessType]}
        />
    </Tooltip>
);

AccessTypeIcon.propTypes = {
    accessType: PropTypes.string.isRequired,
    size: PropTypes.oneOf(Object.values(IconSizes)),
    wrapperClass: PropTypes.string,
};

export default withLocalize(AccessTypeIcon);
